<div class="page-title">
	{{initialUtilisateur.uti_prenom}} {{initialUtilisateur.uti_nom}}
</div>

<gz-tabMenu [model]="tabs"></gz-tabMenu>
<ui-view name="utilisateurTabContent" class="pt-2"></ui-view>
